





import { Component, Inject, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { finalize } from 'rxjs';
import { ApiService } from 'src/app/services/api/api.service';
import { Router } from '@angular/router';
import { SuccessModalComponent } from 'src/app/shared/modals/success-modal/success-modal.component';
import { ConfirmActionComponent } from 'src/app/shared/components/confirm-action/confirm-action.component';
import { ErrorModalComponent } from 'src/app/shared/modals/error-modal/error-modal.component';
import { NgSelectComponent } from '@ng-select/ng-select';
import { phoneNumberValidator } from 'src/app/shared/validators/phone-number.validator';
import { AuthService } from 'src/app/services/auth/auth.service';
import { QueryModalComponent } from 'src/app/shared/modals/initial-application-approval-modal.component/query-modal.component';

@Component({
  selector: 'app-igr-assessment-details',
  standalone: false,
  templateUrl: './igr-assessment-details.component.html',
  styleUrl: './igr-assessment-details.component.scss'
})
export class IgrAssessmentDetailsComponent {


  form: FormGroup;
  isDarkMode!: boolean;

  details: any;
  currentUser: any;


  isLoadingPrivileges: boolean = true;
  isInPreviewMode: boolean = false;
  isEditingAllowed: boolean = false;

  isSubmitting: boolean = false;
  isSubmitAttempted: boolean = false;
  isLoading: boolean;

  showErrorMessages: boolean = false;

  itemList!: any[];
  isListUpdated = false;


  vehicleTypes: any[] = [];

  rememberMe: boolean;

  role: string;





  constructor(
    private dialog: MatDialog,
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<IgrAssessmentDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private apiService: ApiService,
    private authService: AuthService,

  ) { }

  ngOnInit(): void {
    this.role = this.authService.getRole();
    this.currentUser = this.authService.getUser()

    this.initForm();

    this.getAllVehicleTypes();

    this.form.get('vehicleTypeId')?.valueChanges.subscribe((id) => {
      const vehicle = this.vehicleTypes.find((v) => v.id === id);
      this.form.patchValue({ vehicleTypeName: vehicle ? vehicle.name : '' });
    });





    if (this.dialogData?.id) {

      this.fetchDetails()
    }

    this.subscribeToprofilingTypeControl()
    this.isInPreviewMode = this.dialogData?.isInPreviewMode;
    this.isEditingAllowed = this.dialogData?.isEditingAllowed;
  }

  initForm(): void {
    this.form = this.fb.group({
      profilingType: [null, [Validators.required]],
      category: [null, [Validators.required]],
    });


    this.fetchProfilingTypes()
  }

  subCategories: any[];

  get categoryControl(): FormControl {
    return this.form.get('category')! as FormControl
  }

  allowEditing() {
    this.isEditingAllowed = true;
  }

  get profilingTypeControl(): FormControl {
    return this.form.get('profilingType')! as FormControl
  }



  subscribeToprofilingTypeControl() {
    this.profilingTypeControl.valueChanges.subscribe((category: any) => {
      if (category) {
        this.fetchCategories(category);
      }
    })
  }


  profilingTypes: any[];
  isFetchingProfilingTypes: boolean;

  fetchProfilingTypes() {
    this.isFetchingProfilingTypes = true;
    this.apiService
      .get(`/utility/profiling-type`)
      .pipe(finalize(() => {
        this.isFetchingProfilingTypes = false;
      }))
      .subscribe((response: any) => {

        this.profilingTypes = response.map(item => ({ ...item, disabled: false }));

      });
  }




  categories = [];
  isFetchingCategories: boolean;

  fetchCategories(profilingTypeId: number) {
    this.isFetchingCategories = true;
    this.categories = null;
    this.categoryControl.reset()
    this.apiService
      .get(`/utility/profiling-category?profilingTypeId=${profilingTypeId}`)
      .pipe(finalize(() => {
        this.isFetchingCategories = false;
      }))
      .subscribe((response: any) => {

        this.categories = response;
      });
  }



  isCategorySelected(categoryId: number): boolean {
    return this.itemList?.some(item => item.category?.categoryId === categoryId);
  }

  isSubCategorySelected(subCategoryId: number): boolean {
    return this.itemList?.some(item => item.subCategory?.id === subCategoryId);
  }


  fetchDetails() {
    this.details = this.dialogData
    this.mapFormValues(this.dialogData)

    this.apiService
      .get(`/assessment/details/${this.dialogData?.id}`)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe((response: any) => {
        this.details = response.data;

        this.itemList = response?.data?.assessmentDetails?.map((item: any) => ({
          category: {
            id: item.profilingCategoryId,
            amount: item.regAmount,
            revenueDescription: item.profilingCategory,
          },
          profilingType: {
            category: item.profilingType,
            id: item.profilingTypeId
          }
        })) || [];


        this.mapFormValues(response?.data)
      });
  }

  mapFormValues(data: any) {
    this.form.patchValue({
      phoneNumber: data?.phoneNumber,
      address: data?.address
    })
  }

  getAllVehicleTypes() {
    this.isLoading = true;
    this.apiService
      .get('/vehicle-type/all')
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe((response: any) => {
        this.vehicleTypes = response.data.map((vehicleType) => ({
          ...vehicleType,
          formattedName: this.toTitleCase(vehicleType.name.replace(/_/g, ' ')),
        }));
      });
  }

  toTitleCase(str: string): string {
    return str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
  }


  closeModal(): void {
    if (!this.isSubmitting) {
      this.dialogRef.close();
    }
  }

  openSuccessModal(message: string) {
    let dialogRef = this.dialog.open(SuccessModalComponent, {
      width: '350px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      data: { successMessage: message },
    });

    dialogRef.afterClosed().subscribe(() => {
      this.dialogRef.close({ reload: true });
    });
  }

  hasAccess(permissions: string[]) {
    return this.authService.hasAnyPermission(permissions)
  }

  openErrorModal(message: string) {
    let dialogRef = this.dialog.open(ErrorModalComponent, {
      width: '350px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      data: { errorMessage: message },
    });

    dialogRef.afterClosed().subscribe(() => { });
  }

  openConfirmationModal({
    title,
    onConfirm,
    onCancel = () => { },
  }: {
    title: string;
    onConfirm: () => void;
    onCancel?: () => void;
  }) {
    this.dialog.open(ConfirmActionComponent, {
      width: '400px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      disableClose: true,
      data: {
        title,
        body: '',
        confirmText: 'Yes',
        lottieIconPath: 'assets/lottie/alert.json',
        onConfirm,
        onCancel,
        showCancelButton: true,
        showConfirmButton: true,
      },
    });
  }

  isQueryingApplication: boolean;
  isApprovingApplication: boolean;
  isUpdatingApplication: boolean;

  queryApplication() {
    let dialogRef = this.dialog.open(QueryModalComponent, {
      width: '350px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      data: {
        entityId: this.details?.id,
        workflowName: 'ASSESSMENT',
        successMessage: 'Application Queried Successfully',
      },
    });

    dialogRef.afterClosed().subscribe(() => {
      this.dialogRef.close({ reload: true });
    });
  }

  approveApplication() {
    this.openConfirmationModal({
      title: 'Are you sure you want to approve this application?',
      onConfirm: () => {
        this.isApprovingApplication = true;



        this.apiService.post('/workflow/get-next-approving-officer', {
          entityId: this.dialogData?.id,
          workflowName: 'ASSESSMENT',
          type: 'APPROVED'
        }).pipe(
          finalize(() => {
            this.isApprovingApplication = false;
          })
        ).subscribe((res) => {
          if (res.success) {
            this.openSuccessModal(res.message)
          }
          else {
            this.openErrorModal(res?.error || res?.message);

          }
        },
          (error) => {
            this.openErrorModal(error || 'Unable to approve application');
          })
      },
      onCancel: () => console.log('Approval action cancelled'),
    });
  }

  updateApplication() {
    this.openConfirmationModal({
      title: 'Are you sure you want to update this assessment?',
      onConfirm: () => {
        this.isUpdatingApplication = true;

        const request = {
          asin: this.details?.asin,
          assessmentYear: this.dialogData?.assessmentYear,
          requests: this.itemList?.map((item) => ({ amount: item.category.amount, profilingCategory: item.category.id, profilingType: item.profilingType.id }))
          // parkId
        };


        this.apiService.post('/assessment/update/' + this.dialogData?.id, request).pipe(
          finalize(() => {
            this.isUpdatingApplication = false;
          })
        ).subscribe((res) => {
          if (res.success) {
            this.openSuccessModal(res.message)
          }
          else {
            this.openErrorModal(res?.error || res?.message);

          }
        },
          (error) => {
            this.openErrorModal(error || 'Unable to update this application');
          })
      },
      onCancel: () => console.log('Update action cancelled'),
    });
  }

  reassessApplication() {
    this.openConfirmationModal({
      title: 'Are you sure you want to create this reassessment?',
      onConfirm: () => {
        this.isUpdatingApplication = true;

        const request = {
          asin: this.details?.asin,
          assessmentYear: this.dialogData?.assessmentYear,
          requests: this.itemList?.map((item) => ({ amount: item.category.amount, profilingCategory: item.category.id, profilingType: item.profilingType.id }))
          // parkId
        };


        this.apiService.post('/assessment/re-assessment/' + this.dialogData?.id, request).pipe(
          finalize(() => {
            this.isUpdatingApplication = false;
          })
        ).subscribe((res) => {
          if (res.success) {
            this.openSuccessModal(res.message)
          }
          else {
            this.openErrorModal(res?.error || res?.message);

          }
        },
          (error) => {
            this.openErrorModal(error || 'Unable to re-assess this application');
          })
      },
      onCancel: () => console.log('Reassessment action cancelled'),
    });
  }


  confirmCreateAssessment() {
    let dialogRef = this.dialog.open(ConfirmActionComponent, {
      width: '400px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      disableClose: true,

      data: {
        title: 'Are you sure you want to create an assessment for this user?',
        body: '',
        confirmText: 'Yes',
        lottieIconPath: 'assets/lottie/alert.json',
        onConfirm: () => {

          this.submitForm()

        },
        onCancel: () => {
          // dialogRef.close()
        },
        showCancelButton: true,
        showConfirmButton: true,
      },
    });
  }

  markListAsUpdated() {
    this.isListUpdated = true;
  }

  addItemToList(): void {
    const formValues = this.form.value;



    if (this.form.valid) {


      const categoryAlreadyAdded = this.itemList?.find((item) => item?.profilingType?.id == formValues?.profilingType && item?.category?.id == formValues?.category)

      if (Boolean(categoryAlreadyAdded)) {
        this.categoryControl.setErrors({ duplicateEntry: categoryAlreadyAdded.category.revenueDescription });
        this.showErrorMessages = false;
        return;
      }



      const profilingType = this.profilingTypes?.find((item: any) => item.id == formValues?.profilingType);
      const category = this.categories?.find((item: any) => item.id == formValues?.category);




      this.itemList?.push({ profilingType, category });



      this.markListAsUpdated()
      this.form.reset();
      this.showErrorMessages = false;


      if (profilingType.id != 1) { //Disable added profiling type(Except for licenses, for which duplicate entries are allowed)
        profilingType.disabled = true;
        this.profilingTypes = [...this.profilingTypes];
      }
    } else {
      this.showErrorMessages = true
    }
  }

  removeItem(index: number): void {
    this.itemList?.splice(index, 1);
    this.markListAsUpdated()

  }

  submitForm(): void {
    this.isSubmitting = true;
    this.form.disable();

    const formValues = this.form?.value;

    const request = {
      asin: this.details?.asin,
      requests: this.itemList?.map((item) => ({ amount: item.category.amount, category: item.category.id, subCategory: item.subCategory.name }))
      // parkId
    };

    this.apiService
      .post(`/taxpayer/create`, request)
      .pipe(
        finalize(() => {
          this.isSubmitting = false;
          this.form.enable()
        })
      )
      .subscribe(
        (response: any) => {
          this.openSuccessModal(response?.message);

          this.dialogRef.close();
        },
        (error) => {
          this.openErrorModal(error?.message);
        }
      );

    this.isSubmitAttempted = true;
  }


}
